import { Group } from '@/components/_common';
import { useDisclosure, useWindowSize } from '@/hooks';
import { Typography, Button, Divider } from 'antd';
import CategoryModal from './CategoryModal';
import { initialTabErrors } from '@/pages/SettingsPages/CustomerSettingsPage';
import CategoryList from './CategoryList';

interface Props {
  handleTabError: (key: keyof typeof initialTabErrors) => void;
  menuActive: boolean;
}

export default function CustomerCategorySettings({ menuActive }: Props) {
  const { width } = useWindowSize();

  const [createModalOpened, createModalActions] = useDisclosure();

  return (
    <>
      <Group position="between">
        <Typography.Title level={4} style={{ margin: 0 }}>
          Categorias
        </Typography.Title>

        {!(width < 992) && (
          <Button type="primary" onClick={createModalActions.open}>
            Criar categoria
          </Button>
        )}
      </Group>

      <Divider />

      <CategoryModal
        open={createModalOpened}
        onCancel={createModalActions.close}
      />

      <CategoryList enabled={menuActive} />
    </>
  );
}
